import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PersonalForm from "./registerFormsFolder/PersonalForm";
import OrganizationDetailForm from "./registerFormsFolder/OrganizationDetailForm";
import OperationDetailsForm from "./registerFormsFolder/OperationDetailsForm";
import FinancialDetailsForm from "./registerFormsFolder/FinancialDetailsForm";

const VendorRegister = () => {
  const navigate = useNavigate();
  const { doesVendorPartnerExists, isOTPVerified, vendorToken, vendorId } =
    useSelector((state) => state.vendorAuth);
  const { isRegistered } = useSelector((state) => state.vendorRegister);
  useEffect(() => {
    if (vendorToken && vendorId) {
      navigate("/vendorportal/dashboard");
    }
  }, [vendorToken, vendorId]);
  const [step, setStep] = useState(0);

  const renderStep = () => {
    switch (step) {
      case 0:
        return <PersonalForm onNext={() => setStep(1)} />;
      case 1:
        return (
          <OrganizationDetailForm
            onNext={() => setStep(2)}
            onBack={() => setStep(0)}
          />
        );
      case 2:
        return (
          <OperationDetailsForm
            onNext={() => setStep(3)}
            onBack={() => setStep(1)}
          />
        );
      case 3:
        return (
          <FinancialDetailsForm
            onNext={() => console.log("Submit form")}
            onBack={() => setStep(2)}
          />
        );
      default:
        return null;
    }
  };

  // useEffect(() => {
  //   if (isRegistered && vendorToken) {
  //     navigate("/vendorportal/dashboard");
  //   }
  // }, [isRegistered, vendorToken]);

  return (
    <div className=" h-screen flex">
      {/* Left Image */}
      <div className="w-1/2 min-h-screen hidden md:block overflow-hidden">
        <img
          src="/assests/vendorPortalImages/vendorLogin.png"
          alt="Background"
          className="h-full p-4 rounded-[65px] w-full object-cover"
        />
      </div>

      {/* OTP Section */}
      <div className="mx-auto   flex justify-center items-center overflow-y-auto">
        <div className="mx-auto  p-6 md:p-4 flex justify-center items-center">
          {renderStep()}
        </div>
      </div>
    </div>
  );
};

export default VendorRegister;
